<script>
/**
 * TaskCommentAttachmentViewer — lightbox de imagem ampliada (AC-M6).
 *
 * Modal centrado (BaseModal centerScreen) controlado por um bus local. Abre via
 * open({ url, fileName }) e fecha por close(). Em erro de load da imagem
 * (URL expirada) emite @refresh para o pai tentar uma URL fresca.
 *
 * Props:
 *  - downloading  loading do botao "Baixar" (o download base64 e assincrono).
 *
 * Emits:
 *  - refresh()  a imagem falhou ao carregar (provavel URL expirada).
 *  - download() clique no botao de download dentro do lightbox.
 */
import Vue from 'vue'

export default {
  name: 'TaskCommentAttachmentViewer',
  props: {
    downloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      url: '',
      fileName: '',
    }
  },
  methods: {
    open({ url, fileName } = {}) {
      this.url = url || ''
      this.fileName = fileName || ''
      this.busModal.$emit('dialog', true)
    },
    close() {
      this.busModal.$emit('dialog', false)
    },
    onImageError() {
      this.$emit('refresh')
    },
    onDownload() {
      this.$emit('download')
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" centerScreen maxWidth="80%">
    <template v-slot:title>
      <span class="text-heading-small ml-4 mt-2">{{ fileName }}</span>
    </template>

    <div class="task-comment-attachment-viewer pa-4 d-flex justify-center">
      <img
        v-if="url"
        :src="url"
        :alt="fileName"
        class="viewer-image"
        @error="onImageError"
      />
      <div v-else class="az-text-small text-color-400 pa-4">
        Não foi possível carregar a imagem.
      </div>
    </div>

    <template v-slot:actions="{ close: closeModal }">
      <BaseButton underlined @click="closeModal"> Fechar </BaseButton>
      <BaseButton primary :disabled="!url" :loading="downloading" @click="onDownload"> Baixar </BaseButton>
    </template>
  </BaseModal>
</template>

<style scoped lang="sass">
.task-comment-attachment-viewer
  .viewer-image
    max-width: 100%
    max-height: 70vh
    object-fit: contain
    border-radius: 8px
</style>
